<template>
    <div>
        <div class="nav-top">
            - 数字资源 -
        </div>
        <div class="nav-content">
            <img src="@/assets/img/s_3.png" alt="">
            <div class="nav-list-box">
                <div @click="changeDept(item.dept_id)"
                    :class=" item.dept_id == query_dept_id?'nav-list-item active':'nav-list-item'"
                    v-for="(item,index) in dept_list" :key="index">
                    {{ item.name }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {
        defineComponent,
        ref,
        onMounted,
        computed,
        watch
    } from "vue";
    import * as Api from "@/views/resource/api";

    import {
        useRoute,
    } from "vue-router";
    import router from "@/router";
    export default defineComponent({
        name: "CsLinks",
        props: {},
        emits: ["updateDept"],
        setup() {
            const route = useRoute();
            const currentPath = computed(() => {
                return router.currentRoute.value.path;
            });
            const query_dept_id = ref(parseInt(route.query.dept_id ? route.query.dept_id : 0));

            watch(
                () => route.query.dept_id,
                (newVal, oldVal) => {
                    if (newVal != oldVal) {
                        query_dept_id.value = newVal;
                    }
                }
            )

            const dept_list = ref([]);

            // 初始化
            onMounted(() => {
                Api.dept_list().then((res) => {
                    if (res.status == 200) {
                        dept_list.value = res.data.list;
                        if (res.data.list.length > 0 && query_dept_id.value == 0) {
                            if ((currentPath.value.search('/resource/list') != -1)) {
                                console.log('这里')
                                router.push({
                                    path: currentPath.value,
                                    query: {
                                        dept_id: res.data.list[0].dept_id
                                    },
                                });
                            }
                        } else {
                            console.log('没在这里')
                        }
                    }
                });
            });



            const changeDept = (dept_id) => {
                console.log(currentPath)
                if ((currentPath.value.search('/resource/list') != -1)) {
                    router.push({
                        path: currentPath.value,
                        query: {
                            dept_id: dept_id
                        },
                    });
                } else if ((currentPath.value.search('/resource/show') != -1)) {
                    router.push({
                        path: '/resource/list/video',
                        query: {
                            dept_id: dept_id
                        },
                    });
                } else if ((currentPath.value.search('/resource/add') != -1)) {
                    router.push({
                        path: '/resource/list/video',
                        query: {
                            dept_id: dept_id
                        },
                    });
                } else if ((currentPath.value.search('/resource/edit') != -1)) {
                    router.push({
                        path: '/resource/list/video',
                        query: {
                            dept_id: dept_id
                        },
                    });
                }
                // if (currentPath.value == '/resource/show') {
                //     router.push({
                //         path: '/resource/list/video',
                //         query: {
                //             dept_id: dept_id
                //         },
                //     });
                // } else {
                //     router.push({
                //         path: currentPath.value,
                //         query: {
                //             dept_id: dept_id
                //         },
                //     });
                // }
            };

            return {
                dept_list,
                changeDept,
                query_dept_id
            };
        },
    });
</script>
<style lang="less" scoped>
    .nav-top {
        font-size: 24px;
        color: #fff;
        background-color: #CB5520;
        line-height: 70px;
        text-align: center;
    }

    .nav-content {
        .nav-list-box {
            min-height: 600px;
            background: url('~@/assets/img/s_2.png') no-repeat center;
            padding-top: 50px;

            .nav-list-item {
                cursor: pointer;
                width: 220px;
                line-height: 56px;
                text-align: center;
                height: 56px;
                font-size: 18px;
                margin: 0 auto;
                color: #333;
                margin-bottom: 10px;
            }

            .active {
                background: url('~@/assets/img/s_title.png') no-repeat center;
            }
        }
    }
</style>